/**
 *  Define a token for the ILoggerService interface
 */
export const ILoggerServiceToken = 'LoggerServiceToken';
//# sourceMappingURL=ILoggerService.js.map